module.exports = __webpack_public_path__ + "static/media/des-2.86efbfc6.png";